// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1csvj","label":"Completed_label__1ldot"};